/*
 * hyperion-index:begin
 * ---
 * path: hyperion-cloud/web/src/platform/realtime/components/BrowserNotificationDispatcher.tsx
 * layer: web
 * area: components
 * kind: component
 * web_root: components
 * relpath: web/src/platform/realtime/components/BrowserNotificationDispatcher.tsx
 * filename: BrowserNotificationDispatcher.tsx
 * extension: tsx
 * ---
 * hyperion-index:end
 */

export function BrowserNotificationDispatcher() {
  return null;
}
